import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { GruppoTipiDanno } from 'src/app/models/gruppo-tipi-danno';
import { GruppoTipiDannoService } from 'src/app/services/gruppo-tipi-danno.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditGruppoTipiDannoComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'gruppi-tipi-danno',
  templateUrl: './gruppi-tipi-danno.component.html',
  styleUrls: ['./gruppi-tipi-danno.component.scss']
})
export class GruppiTipiDannoComponent implements OnInit {


  headingText: string = 'Gruppi tipi di danno';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Descrizione',
        internalName: 'descrizione',
      }
    ),

  ];
  constructor(public gruppoTipiDannoService: GruppoTipiDannoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<GruppiTipiDannoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un gruppo di tipi di danno';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (gruppoTipiDanno: GruppoTipiDanno) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il gruppo di tipi di danno ${gruppoTipiDanno.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.gruppoTipiDannoService.delete(gruppoTipiDanno);
          this.toast.success('Gruppo di tipi di danno eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione gruppo di tipi di danno fallita.", "Errore!");
    }
  }



  editFunction = async (gruppoTipiDanno: GruppoTipiDanno) => {
    try {
      let dialogRef = this.dialog.open(EditGruppoTipiDannoComponent, { data: gruppoTipiDanno });
      dialogRef.afterClosed().subscribe(async (data: GruppoTipiDanno) => {
        if (data) {

          Object.assign(gruppoTipiDanno, data);

          await this.gruppoTipiDannoService.edit(gruppoTipiDanno);

          this.toast.success('Gruppo di tipi di danno modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica gruppo di tipi di danno fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditGruppoTipiDannoComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(gruppoTipiDanno?: GruppoTipiDanno) {
    if (gruppoTipiDanno) {
      try {
        await this.gruppoTipiDannoService.create(gruppoTipiDanno)
        this.toast.success('Gruppo di tipi di danno creato!')
      }
      catch (e) {
        this.toast.error('Creazione gruppo di tipi di danno fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
